export const getRefundAmount = ({ price, discount }) => {
  const discountedAmount = parseFloat(price) * (parseFloat(discount) / 100);
  return discountedAmount.toFixed(2);
};

